<template>
	<div class="partial partial--home home" id="home">
		<HomeNav class="home__nav" />

		<TransitionGroup
			name="grid"
			class="home__content"
			tag="div">
			<!-- LEADERSHIP -->
			<div class="section__heading section__heading--leadership" v-show="!theFilter" key="heading_leadership">
				<div class="section__head">
					<IconCircle class="section__icon section__icon--leadership" style="--background: var(--color--leadership);" icon="person" />
					<h2 class="section__title">Leadership</h2>
				</div>
				<div class="section__description">
					As a strategic partner, we leverage our decades of experience and deep expertise to galvanize, lead and support the industry through transformational change.
				</div>
			</div>

			<div class="t-grid" v-show="!theFilter || theFilter == 'leadership'" key="grid_leadership">
				<ContentBox :width="2" :height="2" :to="{name: 'ceo'}" :style="{'--bg': `url('${$src('/assets/images/home/creating-the-market-infrastructure-of-the-future.jpg')}')`}" style="--hover: var(--root--color--leadership)">
					<div class="title title--1">Creating the Market Infrastructure of the Future</div>
					<div class="title title--author">FRANK LA SALLA <span>President & CEO, DTCC</span></div>
				</ContentBox>
				<ContentBox width="1" height="1" class="slash">
					<ChevronMove height="182" style="--color: var(--color--leadership);" />
				</ContentBox>
				<ContentBox width="1" height="1" class="chart">
					<div class="title title--4">Total Revenue</div>
					<NumberBars title="" unit="(USD in Millions)" :numbers="charts.totalRevenue" :mini="true" style="--number-color: var(--color--leadership)"  />
				</ContentBox>
				<ContentBox width="2" height="2" :to="{name: 'cfo'}" :style="{'--bg': `url('${$src('/assets/images/home/architects-of-enterprise-transformation.jpg')}')`}" style="--hover: var(--root--color--leadership)">
					<div class="title title--1">Investing and Delivering for Our Clients</div>
					<div class="title title--author">renee laroche-morris <span>Chief Financial Officer, DTCC</span></div>
				</ContentBox>
				<ContentBox width="2" height="1" external="https://www.dtcc.com/about/leadership/executive-committee" :style="{'--bg': `url('${$src('/assets/images/home/meet-our-executive-committee.jpg')}')`}" style="--hover: var(--root--color--leadership)">
					<div class="title title--2 color--dark-green">Meet Our Executive Committee</div>
				</ContentBox>
				<ContentBox width="2" height="1" external="https://www.dtcc.com/about/leadership/board" :style="{'--bg': `url('${$src('/assets/images/home/meet-our-board-of-directors.jpg')}')`}" style="--hover: var(--root--color--leadership)">
					<div class="title title--2">Meet Our Board of Directors</div>
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/leadership-image--1.jpg')}')`}"></ContentBox>
				<ContentBox width="1" height="1" class="slide">
					<SlidesAwards />
				</ContentBox>
				<ContentBox width="2" height="1" class="slash">
					<SlashMove height="318" style="--color: var(--color--leadership)" />
				</ContentBox>
				<ContentBox width="2" height="1" external="https://www.dtcc.com/-/media/Files/Downloads/legal/financials/2024/DTCC--Annual-2024-Financial-Statements.pdf" video="/assets/media/video-bg--leadership_financials.mp4" style="--hover: var(--root--color--leadership)">
					<div class="title title--2 color--dark-green">Consolidated <br> Financial <br> Statements</div>
				</ContentBox>
			</div>
			<!-- /LEADERSHIP -->

			<!-- VALUE -->
			<div class="section__heading section__heading--value" v-show="!theFilter" key="heading_value">
				<div class="section__head">
					<IconCircle class="section__icon section__icon--value" style="--background: var(--color--value);" icon="diamond" />
					<h2 class="section__title">Delivering <br>Value</h2>
				</div>
				<div class="section__description">
					Throughout the year, DTCC delivered maximum value to the industry through bold leadership, innovative products and services and an unwavering commitment to serving our clients.
				</div>
			</div>

			<div class="t-grid" v-show="!theFilter || theFilter == 'value'" key="grid_value">
				<ContentBox :width="2" :height="2" :to="{name: 'fixed-income'}" video="/assets/media/video-bg--value_fixed-income.mp4" style="--hover: var(--root--color--value)">
					<div class="title title--1">Fixed Income <br class="br--mobile"> Clearing <br class="br--mobile"> Corporation</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="chart">
					<div class="title title--4">Total Value of Securities Processed</div>
					<NumberBars title="" unit="(IN QUADRILLIONS)" :numbers="charts.totalValueSecurities" :mini="true" style="--number-color: var(--color--value)"  />
				</ContentBox>
				<ContentBox width="1" height="1" :to="{name: 'wealth-management'}" :style="{'--bg': `url('${$src('/assets/images/home/wealth-management-services.jpg')}')`}" style="--hover: var(--root--color--value)">
					<div class="title title--3">Wealth Management Services</div>
				</ContentBox>
				<ContentBox width="1" height="1" :to="{name: 'trade-processing'}" video="/assets/media/video-bg--value_itp.mp4" style="--hover: var(--root--color--value)">
					<div class="title title--3 color--dark-green">Institutional <br> Trade <br> Processing</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="chart">
					<div class="title title--4">Asset Services</div>
					<NumberBars title="NUMBER OF ACTIVE SECURITY ISSUES HELD AT DTCC" unit="(IN MILLIONS)" :numbers="charts.totalAssetServices" :mini="true" style="--number-color: var(--color--value)"  />
				</ContentBox>
				<ContentBox width="2" height="1" class="slash">
					<SlashMove height="308" style="--color: var(--color--value)" />
				</ContentBox>
				<ContentBox width="2" height="2" :to="{name: 'national-securities-clearing-corporation'}" :style="{'--bg': `url('${$src('/assets/images/home/national-securities-clearing-corporation.jpg')}')`}" style="--hover: var(--root--color--value)">
					<div class="title title--1">National <br> Securities <br> Clearing <br> Corporation</div>
				</ContentBox>
				<ContentBox width="1" height="1" :to="{name: 'repository'}" :style="{'--bg': `url('${$src('/assets/images/home/repository-derivatives-services.jpg')}')`}" style="--hover: var(--root--color--value)">
					<div class="title title--3">Repository & Derivatives Services</div>
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/national-securities-clearing-corporation-numbers.jpg')}')`}">
					<div class="title title--4">National Securities Clearing Corporation</div>
						<div class="title title--6 mb-1">AVERAGE DAILY VALUE OF NSCC TRANSACTIONS PROCESSED <br>
						<small class="mb-1" style="font-size: 14px; font-weight: 200;">(USD IN TRILLIONS)</small>
					</div>

					<div class="title title--80">$2.219</div>
					<!-- <Counter :number="2.219" :options="{prefix: '$', decimalPlaces: 3}" class="title title--3" /> -->
				</ContentBox>
				<ContentBox width="1" height="1" :to="{name: 'consulting-services'}" video="/assets/media/video-bg--value_consulting-services.mp4" style="--hover: var(--root--color--value)">
					<div class="title title--3">Consulting <br> Services</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="chart">
					<div class="title title--4">Settlement</div>
					<NumberBars title="TOTAL VALUE OF TRANSACTIONS SETTLED" unit="(USD IN TRILLIONS)" :numbers="charts.totalValueTransactions" :mini="true" style="--number-color: var(--color--value)"  />
				</ContentBox>
				<ContentBox width="2" height="1" :to="{name: 'dtcc-digital-assets'}" video="/assets/media/video-bg--value_digital-assets.mp4" style="--hover: var(--root--color--value)">
					<div class="title title--2">DTCC <br> Digital Assets</div>
				</ContentBox>
				<ContentBox width="2" height="1" :to="{name: 'data-services'}" :style="{'--bg': `url('${$src('/assets/images/home/data-services.jpg')}')`}" style="--hover: var(--root--color--value)">
					<div class="title title--2">Data <br> Services</div>
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/value-image--1.jpg')}')`}">
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/value-image--2.jpg')}')`}">
				</ContentBox>
			</div>
			<!-- /VALUE -->

			<!-- INSIGHTS -->
			<div class="section__heading section__heading--insights" v-show="!theFilter" key="heading_insights">
				<div class="section__head">
					<IconCircle class="section__icon section__icon--insights" style="--background: var(--color--insights);" icon="star" />
					<h2 class="section__title">Insights Into <br>Action</h2>
				</div>
				<div class="section__description">
					Standing at the center of global trading activity, we put our clients at the center of our focus and turn insights into positive action.
				</div>
			</div>

			<div class="t-grid" v-show="!theFilter || theFilter == 'insights'" key="grid_insights">
				<ContentBox width="2" height="2" :to="{name: 'accelerated-settlement'}" video="/assets/media/video-bg--insights_accelerated.mp4" style="--hover: var(--root--color--insights)">
					<div class="title title--1">Accelerated <br> Settlement <br> (T+1)</div>
				</ContentBox>
				<ContentBox width="1" height="1" video="/assets/media/video-bg--insights_action-affirmation.mp4">
					<Counter :number="94.55" :options="{suffix: '%', decimalPlaces: 2}" class="title title--80 color--dark-green" />
					<div class="title title--4 color--dark-green">Affirmation Rate for T+1 as of May 29, 2024</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="slide">
					<SlidesLocations />
				</ContentBox>
				<ContentBox width="2" height="2" :to="{name: 'us-treasury-clearing'}" :style="{'--bg': `url('${$src('/assets/images/home/u-s-treasury-clearing.jpg')}')`}" style="--hover: var(--root--color--insights)">
					<div class="title title--1">U.S. Treasury <br>Clearing</div>
				</ContentBox>
				<ContentBox width="2" height="1" external="https://www.dtcc.com/dtcc-connection/articles/2024/may/29/building-the-digital-assets-ecosystem" style="--hover: var(--root--color--insights)">
					<div class="title title--2">Architecting a Dynamic Financial Ecosystem</div>
				</ContentBox>
				<ContentBox width="2" height="2" :to="{name: 'digital-assets'}" :style="{'--bg': `url('${$src('/assets/images/home/digital-assets.jpg')}')`}" style="--hover: var(--root--color--insights)">
					<div class="title title--1">Digital Assets</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="slash">
					<ChevronMove height="180" style="--color: var(--color--insights)" />
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/insights-image--1.jpg')}')`}">
				</ContentBox>
				<ContentBox width="2" height="2" :to="{name: 'advancing-modernization'}" video="/assets/media/video-bg--insights_advancing-modernization.mp4" style="--hover: var(--root--color--insights)">
					<div class="title title--1">Advancing Modernization</div>
				</ContentBox>
				<ContentBox width="2" height="1" video="/assets/media/video-bg--insights_usd.mp4">
					<div class="title title--80">USD$10 TRILLION</div>
					<div class="title title--4">FICC Surpasses USD$10 Trillion in Daily Activity</div>
				</ContentBox>
				<ContentBox width="2" height="1" class="slash">
					<SlashMove height="308" style="--color: var(--color--insights)" />
				</ContentBox>
				<ContentBox width="2" height="1" video="/assets/media/video-bg--insights_16tril.mp4">
					<div class="title title--80">$16 TRILLION</div>
					<div class="title title--4">Tokenization of global illiquid assets is projected to be a $16 trillion business opportunity by 2030.</div>
				</ContentBox>
			</div>
			<!-- /INSIGHTS -->

			<!-- RESPONSIBILITY -->
			<div class="section__heading section__heading--responsibility" v-show="!theFilter" key="heading_responsibility">
				<div class="section__head">
					<IconCircle class="section__icon section__icon--responsibility" style="--background: var(--color--responsibility);" icon="heart" />
					<h2 class="section__title">Responsibility</h2>
				</div>
				<div class="section__description">
					DTCC's purpose-driven culture enables us to embrace our mission and values with excitement and energy. At DTCC, our company is not just a place to work — it's where our people make a difference every day as responsible corporate citizens.
				</div>
			</div>

			<div class="t-grid" v-show="!theFilter || theFilter == 'responsibility'" key="grid_responsibility">
				<ContentBox width="2" height="2" external="https://www.dtcc.com/annuals/2024/files/DTCC-Responsible-Business-Report-2024.pdf" :style="{'--bg': `url('${$src('/assets/images/home/responsible.jpg')}')`}" style="--hover: var(--root--color--responsibility)">
					<div class="title title--1">Responsible <br> Business Report</div>
				</ContentBox>
				<ContentBox width="2" height="1" :style="{'--bg': `url('${$src('/assets/images/home/renee-laroche-morris.jpg')}')`}">
					<div class="title title--4 line--125">“We take pride in creating economic value for employees, shareholders and society through job creation and strong financial performance – all while investing in innovation and improving local communities.”</div>
					<div class="title title--author title--author--small title--author--quote">Fikir Sanders <span>DTCC CSR and ESG Reporting Director</span></div>
				</ContentBox>
				<ContentBox width="1" height="1" :style="{'--bg': `url('${$src('/assets/images/home/2024-total-philanthropic-giving.jpg')}')`}">
					<Counter :number="3447006" :options="{prefix: '$'}" class="title title--55" />
					<div class="title title--4">2024 Total Philanthropic Giving</div>
				</ContentBox>
				<ContentBox width="1" height="1" video="/assets/media/video-bg--responsibility_volunteer.mp4">
					<Counter :number="18400" class="title title--60 color--dark-green" />
					<div class="title title--4 color--dark-green">2024 Volunteer Hours</div>
				</ContentBox>
				<ContentBox width="1" height="1" class="slash">
					<ChevronMove height="180" style="--color: var(--color--responsibility)" />
				</ContentBox>
				<ContentBox width="1" height="1" class="slide">
					<SlidesResponsibility />
				</ContentBox>
				<ContentBox width="2" height="1" class="slide">
					<SlidesPhotos />
				</ContentBox>
				<ContentBox width="1" height="1" class="content-box--2x1--mobile">
					<img src="@/assets/images/home/TIME_MidSizeCompanies_2024_Logo_Basic-03_1020.png" alt="award" style="margin: auto; object-fit:contain; max-height: 100%;" />
				</ContentBox>
				<ContentBox width="2" height="1" video="/assets/media/video-bg--responsibility_quote.mp4">
					<div class="title title--4 line--125">“In 2024, we launched a sustainability pitch contest that invited employees to learn about DTCC’s sustainable business practices and propose ways to reduce our environmental impact by minimizing waste and energy consumption.”</div>
					<div class="title title--author title--author--small title--author--quote">Craig DeFelice <span>DTCC WDS Facilities Director</span></div>
				</ContentBox>
				<ContentBox width="1" height="1" class="content-box--2x1--mobile">
					<div class="title title--4 font--sans weight--400 mb-1 mt-0 text--uppercase color--yellow ">“I have grown and accelerated my development as a leader.”</div>
					<div class="title title--author title--author--small title--author--quote">Cristina Diaz <span>Client Analytics &
Reporting Associate Director</span></div>
				</ContentBox>
			</div>
			<!-- /RESPONSIBILITY -->
		</TransitionGroup>
	</div>

	<div id="home_page" class="home__dialog">
		<div class="home__page-scrum" @click.prevent.stop="closeDialog"></div>
		<div class="home__page-scroll">
			<div class="home__page">
				<div class="home__page-close" @click.prevent.stop="closeDialog"><img src="@/assets/icons/x.svg" alt="close icon" /></div>
				<div class="home__page-content">
					<RouterView name="Page" />
				</div>
			</div>
		</div>
	</div>
<!--
	<dialog id="home_page" class="home__dialog">
		<div class="home__page">
			<div class="home__page-close" @click.prevent.stop="closeDialog"><img src="@/assets/icons/x.svg" alt="close icon" /></div>
			<div class="home__page-content">
				<RouterView name="Page" />
			</div>
		</div>
	</dialog> -->

	<svg class="clip-svg" width="0" height="0">
		<defs>
			<clipPath id="squircle-2x2" clipPathUnits="objectBoundingBox">
				<path d="M1 0.062C1 0.0278 0.972 0 0.938 0H0.062C0.0278 0 0 0.0278 0 0.062V0.938C0 0.972 0.0278 1 0.062 1H0.805C0.821 1 0.837 0.993 0.849 0.981L0.982 0.849C0.993 0.837 1 0.821 1 0.805V0.062Z" />
			</clipPath>
			<clipPath id="squircle-2x1" clipPathUnits="objectBoundingBox">
				<path d="M1 0.13C1 0.058 0.972 0 0.938 0H0.062C0.028 0 0 0.058 0 0.13V0.87C0 0.942 0.028 1 0.062 1H0.806C0.822 1 0.838 0.987 0.85 0.962L0.982 0.684C0.994 0.66 1 0.627 1 0.592V0.13Z" />
			</clipPath>
			<clipPath id="squircle-1x1" clipPathUnits="objectBoundingBox">
				<path d="M1 0.13C1 0.058 0.942 0 0.871 0H0.13C0.058 0 0 0.058 0 0.13V0.871C0 0.942 0.058 1 0.13 1H0.592C0.627 1 0.66 0.987 0.684 0.962L0.962 0.684C0.987 0.66 1 0.627 1 0.592V0.13Z" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
import { useHead } from '@unhead/vue'
import { findInHistory, $src } from '@/lib/utils'
import { smoothscroll } from '@/lib/utils/smoothscroll'
import { Smooth } from '@/lib/utils/smoothscroll'

import Chevron from '@/components/Chevron.vue'
import ChevronMove from '@/components/ChevronMove.vue'
import ContentBox from '@/components/ContentBox.vue'
import Counter from '@/components/Counter.vue'
import HomeNav from '@/components/HomeNav.vue'
import IconCircle from '@/components/IconCircle.vue'
import NumberBars from '@/components/NumberBars.vue'
import SlashMove from '@/components/SlashMove.vue'
import SlidesAwards from '@/components/SlidesAwards.vue'
import SlidesERG from '@/components/SlidesERG.vue'
import SlidesLocations from '@/components/SlidesLocations.vue'
import SlidesPhotos from '@/components/SlidesPhotos.vue'
import SlidesResponsibility from '@/components/SlidesResponsibility.vue'
import NumberBlock from '@/components/NumberBlock.vue'


export default {
	name: 'PartialHome',
	components: {
		Chevron,
		ChevronMove,
		ContentBox,
		Counter,
		HomeNav,
		IconCircle,
		NumberBars,
		NumberBlock,
		SlashMove,
		SlidesAwards,
		SlidesERG,
		SlidesLocations,
		SlidesPhotos,
		SlidesResponsibility,
	},
	setup() {
		useHead({
			title: `Our Year of Execution`,
		})
	},
	data: () => ({
		dialog: null,
		theFilter: null,
		charts: {
			totalRevenue: [
				{
					value: 2486,
					label: '2024',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
				{
					value: 2246,
					label: '2023',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
				{
					value: 2163,
					label: '2022',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
			],
			totalValueSecurities: [
				{
					value: 3.80,
					label: '2024',
					options: {
						decimalPlaces: 2,
						prefix: '$',
					},
				},
				{
					value: 3.00,
					label: '2023',
					options: {
						decimalPlaces: 2,
						prefix: '$',
					},
				},
				{
					value: 2.50,
					label: '2022',
					options: {
						decimalPlaces: 2,
						prefix: '$',
					},
				},
			],
			totalAssetServices: [
				{
					value: 1.42,
					label: '2024',
					options: {
						decimalPlaces: 2,
						prefix: '',
					},
				},
				{
					value: 1.40,
					label: '2023',
					options: {
						decimalPlaces: 2,
						prefix: '',
					},
				},
				{
					value: 1.40,
					label: '2022',
					options: {
						decimalPlaces: 2,
						prefix: '',
					},
				},
			],
			activeSecurityIssues: [
				{
					value: 2.50,
					label: '2022',
					options: {
						decimalPlaces: 2,
						prefix: '',
					},
				},
				{
					value: 1.4,
					label: '2022',
					options: {
						decimalPlaces: 2,
						prefix: '',
					},
				},
			],
			totalValueTransactions: [
				{
					value: 525,
					label: '2024',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
				{
					value: 446,
					label: '2023',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
				{
					value: 462,
					label: '2022',
					options: {
						decimalPlaces: 0,
						prefix: '$',
					},
				},
			],
		},

	}),
	mounted() {
		this.dialog = document.querySelector('.home__dialog')
		if (this.$route?.matched.length == 3 && this.dialog) {
			this.showDialog()
		}

		const pageSmooth = new Smooth(document.querySelector('.home__page-scroll'))
		pageSmooth.init()
		pageSmooth.enable()
	},
	methods: {
		escape(e) {
			if (e.key === 'Escape') {
				this.closeDialog()
			}
		},
		closeDialog(evt, checkTarget) {
			this.dialog?.classList.remove('home__dialog--visible')
			document.removeEventListener('keyup', this.escape)
			// if (checkTarget && evt.target !== this.dialog) return
			// this.dialog?.close()
			setTimeout(() => {
				let step = findInHistory('/')
				console.log('close', step)
				if (step < 0) {
					this.$router.push({name: 'home'})
				} else {
					this.$router.go(step)
				}
			}, 350)
		},
		showDialog() {
			this.dialog?.classList.add('home__dialog--visible')
			document.addEventListener('keyup', this.escape)
		},
	},
	watch: {
		$route: {
			immediate: true,
			handler(to, from) {
				this.theFilter = to.params?.filter
				if (this.dialog) {
					if (to.matched.length == 3){
						this.showDialog()
						requestAnimationFrame(() => {
							const pg = document.querySelector('.home__dialog')
							smoothscroll(pg)
						})
					} else {
						this.dialog?.classList.remove('home__dialog--visible')
					}
				}
			},
		}
	}
}
</script>

<style scoped lang="scss">
.home {
	--gap: 1.75rem;
	--gutter: 3.75rem;
	--radius: var(--border-radius);

	scroll-margin-top: 1.5rem;

	@include modules.media-query('phone') {
		--page-width: 100vw;
		--open-x: 0vw;
	}

	@include modules.media-query('phone') {
		--gap: 1.25rem;
		--gutter: 1.25rem;
		--radius: var(--border-radius--phone);
	}

	max-width: var(--max-width);
	margin-left: auto;
	margin-right: auto;
	padding: 0 var(--gutter);
	position: static;
	width: 100%;

	.section {
		&__heading {
			border-top: 1px solid var(--color--mint);
			column-gap: 1rem;
			display: grid;
			grid-template-columns: 1fr 1fr;
			padding: 2.5rem 0;

			&--value {
				border-top-color: var(--color--value);
				margin-top: 7rem;

				@include modules.media-query('phone') {
					margin-top: 3.5rem;
				}
			}

			&--insights {
				border-top-color: var(--color--insights);
				margin-top: 7rem;

				@include modules.media-query('phone') {
					margin-top: 3.5rem;
				}
			}

			&--responsibility {
				border-top-color: var(--color--responsibility);
				margin-top: 7rem;

				@include modules.media-query('phone') {
					margin-top: 3.5rem;
				}
			}

			@include modules.media-query('phone') {
				grid-template-columns: auto;
			}

			@include modules.media-query('tablet') {
				grid-template-columns: auto;
			}
		}

		&__head {
			align-items: flex-start;
			column-gap: var(--gap);
			display: grid;
			flex: 1;
			grid-template-columns: auto 1fr;

			@include modules.media-query('phone') {
				flex-direction: column;
				grid-template-columns: auto;
			}
		}

		&__description {
			flex: 1;
			font-family: var(--font-family--body);
			font-size: 1.375rem;
			font-weight: 275;
		}

		&__icon {
			--size: var(--icon-size);
		}

		&__title {
			flex: 1;
			font-family: var(--font-family--body);
			font-size: 4.0625rem;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.08125rem;
			line-height: 4.875rem; /* 120% */
			margin: 0;
			margin-left: auto;
			margin-right: auto;
			padding: 0;
			text-align: left;
			white-space: pre-line;

			@include modules.media-query('phone') {
				font-size: 3.4rem;
				margin: 2rem 0;
				text-align: left;
			}


			@include modules.media-query('tablet') {
				text-align: left;
				width: 100%;
			}
		}
	}

	.t-grid {
		display: grid;
		gap: var(--gap);
		grid-template-columns: repeat(4, 1fr);
		grid-auto-rows: 1fr;

		@include modules.media-query('phone') {
			grid-template-columns: repeat(2, 1fr);
			grid-auto-rows: auto;
		}
	}

	&__dialog {
		background-color: rgba(0,0,0,0.5);
		height: 100vh;
		left: 0;
		outline: 0;
		// overflow-y: auto;
		padding: 0;
		top: 0;
		position: fixed;
		margin: 0;
		opacity: 0;
		transform: translateX(-100vw);
		transition: opacity 450ms cubic-bezier(.4,0,.2,1), transform 0ms linear 600ms;
		width: 100vw;
		z-index: 90;

		.home__page {
			transform: translateX(-100vw);
			transition: transform 350ms cubic-bezier(.4,0,.2,1);
			transition-delay: 0ms;
		}

		&--visible {
			transition: opacity 450ms cubic-bezier(.4,0,.2,1), transform 0ms linear 0ms;
			transform: translateX(0);
			opacity: 1;

			.home__page {
				transform: translateX(0);
				transition-delay: 150ms;
			}
		}

		/* hide scrollbar */
		-ms-overflow-style: none;
    	scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}
	}

	&__page {
		max-width: var(--page-width);
		position: relative;
		z-index: 9;
		width: 100%;

		&-close {
			cursor: pointer;
			position: sticky;
			float: right;
			top: 0.5em;
			margin-right: var(--border-radius);
			margin-top: var(--border-radius);
			z-index: 11;
		}

		&-content {
			margin-block: var(--border-radius);
		}

		&-scroll {
			width: 100vw;
			height: 100vh;
			overflow-y: auto;
			z-index: 9;
		}

		&-scrum {
			position: fixed;
			left: 0;
			top: 0;
			right: 0;
			height: 100vh;
			width: 100vw;
			z-index: 7;
		}
	}
}

.grid {
	&-enter-active,
	&-leave-active {
		transition: all 250ms ease-out;
	}

	&-enter-from,
	&-leave-to {
		opacity: 0;
		transform: translateY(15vh);
	}
}
.grid-move {
	transform: scale(0.8);
}

:deep(.slides img) {
	@include modules.media-query('phone') {
		max-width: 100%;
		margin-left: auto;
		margin-right: auto;

		&.ml-auto {
			max-width: 100px;
		}
	}
}


@keyframes close {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(-100vw);
	}
}

@keyframes open {
	from {
		transform: translateX(-100vw);
	}
	to {
		transform: translateX(0);
	}
}

@keyframes backdropClose {
	from {
		background-color: rgba(0, 0, 0, 0.25);
		backdrop-filter: blur(3px);
	}
	to {
		background-color: rgba(0, 0, 0, 0);
		backdrop-filter: blur(0px);
	}
}

@keyframes backdropOpen {
	from {
		background-color: rgba(0, 0, 0, 0);
		backdrop-filter: blur(0px);
	}
	to {
		background-color: rgba(0, 0, 0, 0.25);
		backdrop-filter: blur(3px);
	}
}

</style>
